import _ from 'lodash';

export function   handleNestedErrors(errors) {
  if (errors == null) return null;
  if (errors) {
    Object.keys(errors).forEach(key => {
      if (key.includes('.')) {
        const error = errors[key];
        delete errors[key];
        _.set(errors, key, error);
      }
    });
  }

  return errors;
}



// WEBPACK FOOTER //
// ./src/utils/validation.js